/* global axios */

import liveReports from 'dashboard/api/liveReports';
import reports from 'dashboard/api/reports';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

export const fetchGroupedConversations = ({
  groupBy = 'assignee_id',
  inboxId = null,
  from = null,
  to = null,
} = {}) => {
  return axios.get(`${liveReports.url}/grouped_conversation_metrics`, {
    params: {
      group_by: groupBy,
      inbox_id: inboxId,
      from,
      to,
    },
  });
};

export const fetchScopedReport = ({
  metric,
  from,
  to,
  type = 'account',
  id,
  groupBy,
  businessHours,
  inboxId,
}) => {
  return axios.get(reports.url, {
    params: {
      metric,
      since: from,
      until: to,
      type,
      id,
      group_by: groupBy,
      business_hours: businessHours,
      inbox_id: inboxId,
      timezone_offset: getTimeOffset(),
    },
  });
};

export const fetchScopedSummary = ({
  since,
  until,
  inboxId,
  type = 'account',
  id,
  groupBy,
  businessHours,
}) => {
  return axios.get(`${reports.url}/summary`, {
    params: {
      since,
      until,
      type,
      id,
      group_by: groupBy,
      business_hours: businessHours,
      inbox_id: inboxId,
      timezone_offset: getTimeOffset(),
    },
  });
};

export const fetchMessagesByAgent = ({ since, until, inboxId }) => {
  return axios.get(`${reports.url}/outgoing_messages_count`, {
    params: {
      group_by: 'message_agent',
      since,
      until,
      inbox_id: inboxId,
    },
  });
};

// One request for ALL selected inboxes prevents cross-inbox double counting.
export const fetchDailyMovements = ({
  since,
  until,
  inboxIds = [],
  groupBy = 'day',
}) => {
  return axios.get(reports.url, {
    params: {
      metric: 'most_daily_movements',
      since,
      until,
      inbox_ids: inboxIds,
      group_by: groupBy,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
};
